import React, { useState, useEffect, useReducer } from "react";
import {
  fetchEndpointData,
  GetDashboardCompaniesAPI,
  GetEmailData,
  GetSponsorshipDonationsData,
  GetHealthcareData,
  GetFIGData,
  GetConsumerRetailMemberTimeLog,
  GetConsumerRetailProjectTimeLog,
  GetGPCMemberTimeLog,
  GetGPCProjectTimeLog,
  GetMergersAndAcquisitionsData,
  GetCMEMemberTimeLog,
  GetCMEProjectTimeLog,
  GetCMEGroupHeadProjectTimeLog,
  GetRealEstateData,
  GetCMEGroupHeadDealLog,
  GetTechGroupHeadDealTracker,
  GetTechGroupHeadDealLog,
  GetL2LRevenueChartData,
  GetUserSubdepartments,
  GetTechBankerTimeLog,
  GetEnergyBankerTimeLog,
  GetEnergyStafferTimeLog,
  GetStafferDealDetailsandResourcingLog,
  GetEnergySIBankerTimeLog,
  GetEnergySIStafferTimeLog,
  GetSIStafferDealDetailsandResourcingLog,
  GetPowerBankerTimeLog,
  GetPowerStafferProjectAndMemberTracker,
  GetLeveragedFinanceBankerTimeLog,
  GetLeveragedFinanceStafferTimeLog,
  GetLeveragedFinanceDealTracker,
  GetJuniorStaffingIndex,
  GetEnergyProjectHoursByVertical,
} from "../../services/api/dashboard-api";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/user/user-selector";
import DashboardHeader from "./dashboard-header/DashboardHeader/dashboard-header.jsx";
import NoPermissionTable from "../../components/no-permission-table/NoPermissionTable";
import { PulseLoader } from "react-spinners";
import DashboardHealthcare from "./dashboard-healthcare/dashboard-healthcare";
import DashboardConsumerRetail from "./dashboard-consumer-retail/dashboard-consumer-retail";
import DashboardGPC from "./dashboard-gpc/dashboard-gpc";
import DashboardEmailPerformance from "./dashboard-email/dashboard-email-performance";
import DashboardEmailStatus from "./dashboard-email/dashboard-email-status";
import DashboardSponsorshipDonations from "./dashboard-sponsorships/dashboard-sponsorships";
import DashboardFIG from "./dashboard-fig/dashboard-fig";
import DashboardMergersAndAcquisitions from "./dashboard-mergers-and-acquisitions/dashboard-mergers-and-acquisitions.jsx";
// import DashboardLevfinGroupHead from "./dashboard-levfin/grouphead/levfin-group-head.js";
import DashboardRealEstate from "./dashboard-real-estate/dashboard-real-estate.jsx";
import DashboardEnergyBanker from "./dashboard-energy/dashboard-energy-banker/dashboard-energy-banker.jsx";
import DashboardEnergyStaffer from "./dashboard-energy/dashboard-energy-staffer/dashboard-energy-staffer.jsx";
import DashboardPowerBanker from "./dashboard-pui/dashboard-pui-banker/dashboard-pui-banker.jsx";
import DashboardL2L from "./dashboard-L2L/L2L_Dashboard.jsx";
import "./new-dashboard.scss";
// Shared global dashboard styles, loaded once for both the per-industry dashboards and
// the configured (STR) dashboard. See the file header for the TAD-5778 background.
import "./dashboard-shared/dashboard-globals.scss";
import DashboardTechStaffer from "./dashboard-tech/dashboard-tech-staffer/dashboard-tech-staffer.jsx";
import {
  fetchDashboardDynamicFieldsNEW,
  fetchDashboardCarryOverDynamicFields
} from "./dynamic-fields/dashboard-dynamic-fields-util.js";
import * as taskDynamicFieldsUtil from "../../components/DynamicField/Tasks/utils/utils";
import DashboardCME from "./dashboard-cme/dashboard-cme";
import { Helmet } from "react-helmet-async";
import ConfiguredDashboard from "./dashboard-configured/Configured_Dashboard.jsx";
import { compareCurrentSubdepartment, findNewSubdepartment, newDashboardMap, shouldFetchData } from "./new-dashboard-mapper.js";
import DashboardGroupHeadTech from "./dashboard-tech/dashboard-group-head-tech.jsx";
import DashboardTechBanker from "./dashboard-tech/dashboard-tech-banker/dashboard-tech-banker.jsx";
import { DashboardGridSkeleton } from "./dashboard-skeletons/dashboard-skeletons.jsx";
import DashboardPowerStaffer from "./dashboard-pui/power-staffer/dashboard-pui-staffer.jsx";
import LevfinJuniorBanker from "./dashboard-levfin/levfin-junior-banker/levfin-junior-banker.jsx";
import LevfinStaffer from "./dashboard-levfin/levfin-staffer/levfin-staffer.jsx";

const ConfigurableDashboard = window["APP_SETTINGS"].CONFIGURED_DASHBOARD;

const initialDashboardDataState = {
  dynamicFields: [],
  levFinFields: [],
};

const dashboardDataReducer = (state, action) => {
  switch (action.type) {
    case "SET_DYNAMIC_FIELDS":
      return { ...state, dynamicFields: action.payload };
    default:
      return state;
  }
};

const NewDashboard = () => {
  const [departments, setDepartments] = useState(null);
  const [subDepartments, setSubDepartments] = useState(null);
  const [emailItems, setEmailItems] = useState(null);
  const [sponsorshipItems, setSponsorshipItems] = useState(null);
  const [powerBankerTimeLogItems, setPowerBankerTimeLogItems] = useState(null);
  const [powerStafferProjectAndMemberTrackerItems, setPowerStafferProjectAndMemberTrackerItems] = useState(null);
  const [healthcareItems, setHealthcareItems] = useState(null);
  const [FIGAssociateItems, setFIGAssociateItems] = useState(null);
  const [FIGAnalystItems, setFIGAnalystItems] = useState(null);
  const [consumerMemberTimeItems, setConsumerMemberTimeItems] = useState(null);
  const [consumerProjectTimeItems, setConsumerProjectTimeItems] = useState(null);
  const [levfinBankerTimeLogItems, setLevfinBankerTimeLogItems] = useState(null);
  const [levfinStafferTimeLogItems, setLevfinStafferTimeLogItems] = useState(null);
  const [levfinDealTrackerItems, setLevfinDealTrackerItems] = useState(null);
  const [GPCMemberTimeItems, setGPCMemberTimeItems] = useState(null);
  const [GPCProjectTimeItems, setGPCProjectTimeItems] = useState(null);
  const [mergersAndAcquisitionsAssociateUsers, setMergersAndAcquisitionsAssociateUsers] = useState(null);
  const [mergersAndAcquisitionsAnalystUsers, setMergersAndAcquisitionsAnalystUsers] = useState(null);
  const [cMEMemberItems, setCMEMemberItems] = useState(null);
  const [cMEProjectItems, setCMEProjectItems] = useState(null);
  const [cMEGroupHeadProjectItems, setCMEGroupHeadProjectItems] = useState(null);
  const [cMEGroupHeadDealItems, setCMEGroupHeadDealItems] = useState(null);
  const [realEstateUsers, setRealEstateUsers] = useState(null);
  const [techGroupHeadDealTrackerItems, setTechGroupHeadDealTrackerItems] = useState(null);
  const [techGroupHeadDealLogItems, setTechGroupHeadDealLogItems] = useState(null);
  const [techBankerTimeLogItems, setTechBankerTimeLogItems] = useState(null);
  const [L2LRevenueChartData, setL2LRevenueChartData] = useState(null);
  const [energyBankerTimeLogItems, setEnergyBankerTimeLogItems] = useState(null);
  const [energyStafferTimeLogItems, setEnergyStafferTimeLogItems] = useState(null);
  const [energyStafferDealResourceLogItems, setEnergyStafferDealResourceLogItems] = useState(null);
  const [energySIBankerTimeLogItems, setEnergySIBankerTimeLogItems] = useState(null);
  const [energySIStafferTimeLogItems, setEnergySIStafferTimeLogItems] = useState(null);
  const [energySIStafferDealResourceLogItems, setEnergySIStafferDealResourceLogItems] = useState(null);
  const [energyJuniorStaffingIndexData, setEnergyJuniorStaffingIndexData] = useState(null);
  const [energyProjectHoursByVerticalData, setEnergyProjectHoursByVerticalData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [dashboardData, dashboardDataDispatch] = useReducer(
    dashboardDataReducer,
    initialDashboardDataState
  );
  const [currDepartment, setCurrDepartment] = useState(null);
  const [currSubDepartment, setSubCurrDepartment] = useState("");
  const currentUser = useSelector(selectUser);
  const showDashboard = currentUser?.privileges?.Dashboard?.View;
  const [isGIBLoading, setIsGIBLoading] = useState(true);
  const [isGIBCarryOverLoading, setIsGIBCarryOverLoading] = useState(false);
  const [isEmailLoading, setIsEmailLoading] = useState(true);
  const [isSponsorLoading, setIsSponsorLoading] = useState(true);
  const [isHealthLoading, setIsHealthLoading] = useState(true);
  const [isFigAssociateLoading, setIsFigAssociateLoading] = useState(true);
  const [isFigAnalystLoading, setIsFigAnalystLoading] = useState(true);
  const [isConsumerMemberLoading, setIsConsumerMemberLoading] = useState(true);
  const [isConsumerProjectLoading, setIsConsumerProjectLoading] = useState(true);
  const [isLevfinBankerTimeLogLoading, setIsLevfinBankerTimeLogLoading] = useState(true);
  const [isLevfinStafferTimeLogLoading, setIsLevfinStafferTimeLogLoading] = useState(true);
  const [isLevfinDealTrackerLoading, setIsLevfinDealTrackerLoading] = useState(true);
  const [isGPCMemberLoading, setIsGPCMemberLoading] = useState(true);
  const [isGPCProjectLoading, setIsGPCProjectLoading] = useState(true);
  const [isMergerAssociateLoading, setIsMergerAssociateLoading] = useState(true);
  const [isMergerAnalystLoading, setIsMergerAnalystLoading] = useState(true);
  const [isCMEMemberLoading, setIsCMEMemberLoading] = useState(true);
  const [isCMEProjectLoading, setIsCMEProjectLoading] = useState(true);
  const [isCMEGroupHeadProjectLoading, setIsCMEGroupHeadProjectLoading] = useState(true);
  const [isCMEGroupHeadDealLoading, setIsCMEGroupHeadDealLoading] = useState(true);
  const [isTechGroupHeadDealTrackerLoading, setIsTechGroupHeadDealTrackerLoading] = useState(true);
  const [isTechGroupHeadDealLogLoading, setIsTechGroupHeadDealLogLoading] = useState(true);
  const [isTechBankerTimeLogLoading, setIsTechBankerTimeLogLoading] = useState(true);
  const [isRELoading, setIsRELoading] = useState(true);
  const [isL2LRevenueLoading, setIsL2LRevenueLoading] = useState(true);
  const [isEnergyBankerTimeLogLoading, setIsEnergyBankerTimeLogLoading] = useState(true);
  const [isEnergyStafferTimeLogLoading, setIsEnergyStafferTimeLogLoading] = useState(true);
  const [isEnergyStafferDealResourceLogLoading, setIsEnergyStafferDealResourceLogLoading] = useState(true);
  const [isEnergySIBankerTimeLogLoading, setIsEnergySIBankerTimeLogLoading] = useState(true);
  const [isEnergySIStafferTimeLogLoading, setIsEnergySIStafferTimeLogLoading] = useState(true);
  const [isEnergySIStafferDealResourceLogLoading, setIsEnergySIStafferDealResourceLogLoading] = useState(true);
  const [isPowerBankerTimeLogLoading, setIsPowerBankerTimeLogLoading] = useState(true);
  const [isPowerStafferProjectAndMemberTrackerLoading, setIsPowerStafferProjectAndMemberTrackerLoading] = useState(true);
  const [isEnergyJuniorStaffingIndexLoading, setIsEnergyJuniorStaffingIndexLoading] = useState(true);
  const [isEnergyProjectHoursByVerticalLoading, setIsEnergyProjectHoursByVerticalLoading] = useState(true);
  //Rolling back to fetch. Axios was causing issues on MVC for function
  //const fetchDepartmentData = () => fetchEndpointData(GetDashBoardCompanies, setDepartments);
  const fetchDepartmentData = async () => {
    let result = await GetDashboardCompaniesAPI();

    if (result?.data) {
      const modifiedData = result.data.map(item => ({
        ...item,
        id: item.Id,
        companyID: item.Id,
        name: item.Name + (item.Active ? '' : ' (Inactive)')
      }));
      setDepartments(modifiedData);
    } else {
      setDepartments([]);
      console.error('Failed to fetch department data: result or result.data is null/undefined');
    }
  };

  const fetchSubDepartmentData = async () => {
    let result = await GetUserSubdepartments();

    if (result?.data) {
      if (result?.data?.length === 1) {
        result.data = findNewSubdepartment(result.data[0]);
      }

      let savedValue = localStorage.getItem("subdepartment");
      setSubDepartments(result?.data);

      if (savedValue !== null && result?.data.find(x => x === savedValue) !== undefined)
        setSubCurrDepartment(localStorage.getItem("subdepartment"));
      else
        setSubCurrDepartment(result?.data[0]);
    } else {
      setSubDepartments([]);
      console.error('Failed to fetch sub department data: result or result.data is null/undefined');
    }
  };

  const fetchEmailData = () => fetchEndpointData(GetEmailData, setEmailItems);
  const fetchSponsorshipData = () => fetchEndpointData(GetSponsorshipDonationsData, setSponsorshipItems);
  const fetchPowerBankerTimeLog = () => fetchEndpointData(GetPowerBankerTimeLog, setPowerBankerTimeLogItems);
  const fetchPowerStafferProjectAndMemberTracker = () => fetchEndpointData(GetPowerStafferProjectAndMemberTracker, setPowerStafferProjectAndMemberTrackerItems);
  const fetchHealthcareData = () => fetchEndpointData(GetHealthcareData, setHealthcareItems);
  const fetchFIGAssociateData = () => fetchEndpointData(() => GetFIGData("Associate"), setFIGAssociateItems);
  const fetchFIGAnalystData = () => fetchEndpointData(() => GetFIGData("Analyst"), setFIGAnalystItems);
  const fetchConsumerMemberTimeData = () => fetchEndpointData(GetConsumerRetailMemberTimeLog, setConsumerMemberTimeItems);
  const fetchConsumerProjectTimeData = () => fetchEndpointData(GetConsumerRetailProjectTimeLog, setConsumerProjectTimeItems);
  const fetchGPCMemberTimeData = () => fetchEndpointData(GetGPCMemberTimeLog, setGPCMemberTimeItems);
  const fetchGPCProjectTimeData = () => fetchEndpointData(GetGPCProjectTimeLog, setGPCProjectTimeItems);
  const fetchMergersAndAcquisitionsAssociateData = () => fetchEndpointData(() => GetMergersAndAcquisitionsData("Associate"), setMergersAndAcquisitionsAssociateUsers);
  const fetchMergersAndAcquisitionsAnalystData = () => fetchEndpointData(() => GetMergersAndAcquisitionsData("Analyst"), setMergersAndAcquisitionsAnalystUsers);
  const fetchCMEMemberTimeData = () => fetchEndpointData(() => GetCMEMemberTimeLog("Analyst"), setCMEMemberItems);
  const fetchCMEProjectTimeData = () => fetchEndpointData(() => GetCMEProjectTimeLog("Analyst"), setCMEProjectItems);
  const fetchCMEGroupHeadProjectTimeData = () => fetchEndpointData(() => GetCMEGroupHeadProjectTimeLog("Analyst"), setCMEGroupHeadProjectItems);
  const fetchRealEstateData = () => fetchEndpointData(() => GetRealEstateData(""), setRealEstateUsers);
  const fetchCMEGroupHeadDealTrackerWidget = () => fetchEndpointData(GetCMEGroupHeadDealLog, setCMEGroupHeadDealItems);
  const fetchTechGroupHeadDealTrackerWidget = () => fetchEndpointData(GetTechGroupHeadDealTracker, setTechGroupHeadDealTrackerItems);
  const fetchTechGroupHeadDealLogWidget = () => fetchEndpointData(GetTechGroupHeadDealLog, setTechGroupHeadDealLogItems);
  const fetchTechBankerTimeLog = () => fetchEndpointData(GetTechBankerTimeLog, setTechBankerTimeLogItems);
  const fetchL2LRevenueChartData = () => fetchEndpointData(GetL2LRevenueChartData, setL2LRevenueChartData);
  const fetchEnergyTechBankerTimeLog = () => fetchEndpointData(GetEnergyBankerTimeLog, setEnergyBankerTimeLogItems);
  const fetchEnergyTechStafferTimeLog = () => fetchEndpointData(GetEnergyStafferTimeLog, setEnergyStafferTimeLogItems);
  const fetchStafferDealDetailsandResourcingLog = () => fetchEndpointData(GetStafferDealDetailsandResourcingLog, setEnergyStafferDealResourceLogItems);
  const fetchEnergySIBankerTimeLog = () => fetchEndpointData(GetEnergySIBankerTimeLog, setEnergySIBankerTimeLogItems);
  const fetchEnergySIStafferTimeLog = () => fetchEndpointData(GetEnergySIStafferTimeLog, setEnergySIStafferTimeLogItems);
  const fetchEnergySIStafferDealDetailsandResourcingLog = () => fetchEndpointData(GetSIStafferDealDetailsandResourcingLog, setEnergySIStafferDealResourceLogItems);
  const fetchLevfinBankerTimeLog = () => fetchEndpointData(GetLeveragedFinanceBankerTimeLog, setLevfinBankerTimeLogItems);
  const fetchLevfinStafferTimeLog = () => fetchEndpointData(GetLeveragedFinanceStafferTimeLog, setLevfinStafferTimeLogItems);
  const fetchLevfinDealTracker = () => fetchEndpointData(GetLeveragedFinanceDealTracker, setLevfinDealTrackerItems);
  const fetchEnergyJuniorStaffingIndex = (value) => fetchEndpointData(() => GetJuniorStaffingIndex(value), setEnergyJuniorStaffingIndexData);
  const fetchEnergyProjectHoursByVertical = (value) => fetchEndpointData(() => GetEnergyProjectHoursByVertical(value), setEnergyProjectHoursByVerticalData);
  
  useEffect(() => {
    if (ConfigurableDashboard !== "STR") {
      Promise.all([
        fetchDepartmentData(),
        fetchSubDepartmentData()
      ]).then(() => {
        setIsLoading(false);
      }).catch((error) => {
        console.error('Error fetching data:', error);
        setIsLoading(false);
      });
    } else {
      setDepartments([]);
      setSubDepartments([]);
      setIsLoading(false);
    }
  }, []);

  const handleCarryOverFetch = async () => {
    const query = {
      company: currDepartment.id,
      project: 0,
      user: 0,
      userID: 0,
      startDate: new Date("5/20/1999 12:00:00 AM"),
      endDate: new Date("5/20/2200 12:00:00 AM"),
    };

    const dynamicFieldsQuery = {
      startDate: query.startDate.toLocaleDateString("en-us"),
      endDate: query.endDate.toLocaleDateString("en-us"),
      fieldType: taskDynamicFieldsUtil.FIELD_TYPES.time,
      companyId: currDepartment.id,
    };

    setIsGIBCarryOverLoading(true);

    await fetchDashboardCarryOverDynamicFields(dynamicFieldsQuery).then((dynamicFieldsData) => {
      dashboardDataDispatch({
        type: "SET_DYNAMIC_FIELDS",
        payload: dynamicFieldsData,
      });
      setIsGIBCarryOverLoading(false);
    });
  };

  const refreshLoading = (value) => {
    if (value) {
      setIsGIBLoading(true);
      setIsSponsorLoading(true);
      setIsHealthLoading(true);
      setIsFigAssociateLoading(true);
      setIsFigAnalystLoading(true);
      setIsConsumerMemberLoading(true);
      setIsConsumerProjectLoading(true);
      setIsGPCMemberLoading(true);
      setIsGPCProjectLoading(true);
      setIsMergerAssociateLoading(true);
      setIsMergerAnalystLoading(true);
      setIsCMEMemberLoading(true);
      setIsCMEProjectLoading(true);
      setIsCMEGroupHeadProjectLoading(true);
      setIsCMEGroupHeadDealLoading(true);
      setIsRELoading(true);
      setIsTechGroupHeadDealTrackerLoading(true);
      setIsTechGroupHeadDealLogLoading(true);
      setIsTechBankerTimeLogLoading(true);
      setIsEnergyBankerTimeLogLoading(true);
      setIsEnergyStafferDealResourceLogLoading(true);
      setIsEnergyStafferTimeLogLoading(true);
      setIsEnergySIBankerTimeLogLoading(true);
      setIsEnergySIStafferTimeLogLoading(true);
      setIsEnergySIStafferDealResourceLogLoading(true);
      setIsEnergyJuniorStaffingIndexLoading(true);
      setIsEnergyProjectHoursByVerticalLoading(true);
      setIsPowerBankerTimeLogLoading(true);
      setIsPowerStafferProjectAndMemberTrackerLoading(true);
      setIsLevfinBankerTimeLogLoading(true);
      setIsLevfinStafferTimeLogLoading(true);
      setIsLevfinDealTrackerLoading(true);
    }
  };

  const fetchData = (id) => {
    const query = {
      company: id,
      project: 0,
      user: 0,
      userID: 0,
      startDate: new Date("5/20/1999 12:00:00 AM"),
      endDate: new Date("5/20/2200 12:00:00 AM"),
    };

    fetchEmailData().then((result) => {
      setIsEmailLoading(false);
      return result;
    });
    if (shouldFetchData(subDepartments, ['SD'])) {
      fetchSponsorshipData().then(() => setIsSponsorLoading(false));
    }

    if (shouldFetchData(subDepartments, ['FIG'])) {
      fetchFIGAssociateData().then(() => setIsFigAssociateLoading(false));
      fetchFIGAnalystData().then(() => setIsFigAnalystLoading(false));
    }

    if (shouldFetchData(subDepartments, ['PUI'])) {
      fetchPowerBankerTimeLog().then(() => setIsPowerBankerTimeLogLoading(false));
      fetchPowerStafferProjectAndMemberTracker().then(() => setIsPowerStafferProjectAndMemberTrackerLoading(false));
    }

    if (shouldFetchData(subDepartments, ['HC'])) {
      fetchHealthcareData().then(() => setIsHealthLoading(false));
    }

    if (shouldFetchData(subDepartments, ['CR'])) {
      fetchConsumerMemberTimeData().then(() => setIsConsumerMemberLoading(false));
      fetchConsumerProjectTimeData().then(() => setIsConsumerProjectLoading(false));
    }

    if (shouldFetchData(subDepartments, ['LF'])) {
      fetchLevfinBankerTimeLog().then(() => setIsLevfinBankerTimeLogLoading(false));
      fetchLevfinStafferTimeLog().then(() => setIsLevfinStafferTimeLogLoading(false));
      fetchLevfinDealTracker().then(() => setIsLevfinDealTrackerLoading(false));
    }

    if (shouldFetchData(subDepartments, ['GPC'])) {
      fetchGPCMemberTimeData().then(() => setIsGPCMemberLoading(false));
      fetchGPCProjectTimeData().then(() => setIsGPCProjectLoading(false));
    }

    if (shouldFetchData(subDepartments, ['MA'])) {
      fetchMergersAndAcquisitionsAssociateData().then(() => setIsMergerAssociateLoading(false));
      fetchMergersAndAcquisitionsAnalystData().then(() => setIsMergerAnalystLoading(false));
    }

    if (shouldFetchData(subDepartments, ['Tech'])) {
      fetchTechBankerTimeLog().then(() => setIsTechBankerTimeLogLoading(false));
      const dynamicFieldsQuery = {
        startDate: query.startDate.toLocaleDateString("en-us"),
        endDate: query.endDate.toLocaleDateString("en-us"),
        fieldType: taskDynamicFieldsUtil.FIELD_TYPES.time,
        companyId: id,
      };

      fetchDashboardDynamicFieldsNEW(dynamicFieldsQuery).then((dynamicFieldsData) => {
        dashboardDataDispatch({
          type: "SET_DYNAMIC_FIELDS",
          payload: dynamicFieldsData,
        });
        setIsGIBLoading(false);
      });
      fetchTechGroupHeadDealTrackerWidget().then(() => setIsTechGroupHeadDealTrackerLoading(false));
      fetchTechGroupHeadDealLogWidget().then(() => setIsTechGroupHeadDealLogLoading(false));
    }

    if (shouldFetchData(subDepartments, ['RE'])) {
      fetchRealEstateData().then(() => setIsRELoading(false));
    }

    if (shouldFetchData(subDepartments, ['CME'])) {
      fetchCMEMemberTimeData().then(() => setIsCMEMemberLoading(false));
      fetchCMEProjectTimeData().then(() => setIsCMEProjectLoading(false));
      fetchCMEGroupHeadProjectTimeData().then(() => setIsCMEGroupHeadProjectLoading(false));
      fetchCMEGroupHeadDealTrackerWidget().then(() => setIsCMEGroupHeadDealLoading(false));
    }

    if (shouldFetchData(subDepartments, ['L2L'])) {
      fetchL2LRevenueChartData().then(() => setIsL2LRevenueLoading(false));
    }

    if (shouldFetchData(subDepartments, ['Energy'])) {
      fetchEnergyTechBankerTimeLog().then(() => setIsEnergyBankerTimeLogLoading(false));
      fetchEnergyTechStafferTimeLog().then(() => setIsEnergyStafferTimeLogLoading(false));
      fetchStafferDealDetailsandResourcingLog().then(() => setIsEnergyStafferDealResourceLogLoading(false));
      fetchEnergyJuniorStaffingIndex().then(() => setIsEnergyJuniorStaffingIndexLoading(false));
      fetchEnergyProjectHoursByVertical().then(() => setIsEnergyProjectHoursByVerticalLoading(false));
    }

    if (shouldFetchData(subDepartments, ['EnergySI'])) {
      fetchEnergySIBankerTimeLog().then(() => setIsEnergySIBankerTimeLogLoading(false));
      fetchEnergySIStafferTimeLog().then(() => setIsEnergySIStafferTimeLogLoading(false));
      fetchEnergySIStafferDealDetailsandResourcingLog().then(() => setIsEnergySIStafferDealResourceLogLoading(false));
    }
  };

  const GetGIBDynamicData = () => {
    const query = {
      company: currDepartment.id,
      project: 0,
      user: 0,
      userID: 0,
      startDate: new Date("5/20/1999 12:00:00 AM"),
      endDate: new Date("5/20/2200 12:00:00 AM"),
    };

    const dynamicFieldsQuery = {
      startDate: query.startDate.toLocaleDateString("en-us"),
      endDate: query.endDate.toLocaleDateString("en-us"),
      fieldType: taskDynamicFieldsUtil.FIELD_TYPES.time,
      companyId: currDepartment.id,
    };

    fetchDashboardDynamicFieldsNEW(dynamicFieldsQuery).then(
      (dynamicFieldsData) => {
        dashboardDataDispatch({
          type: "SET_DYNAMIC_FIELDS",
          payload: dynamicFieldsData,
        });
      }
    );
  };

  const getIndex = (departmentName) => {
    return departments.findIndex((x) => x.Name === departmentName);
  };

  useEffect(() => {
    if (departments != null && departments.length > 0) {
      let index = getIndex(localStorage.getItem("tmpTriyoToken"));
      if (index < 0) index = 0;
      setCurrDepartment(departments[index]);
    }
  }, [departments]);

  useEffect(() => {
    if (currDepartment && subDepartments) {
      fetchData(currDepartment.id);
    }
  }, [currDepartment, subDepartments]);

  if (ConfigurableDashboard === "STR") {
    if (showDashboard) return <ConfiguredDashboard />
    else return <NoPermissionTable />;
  }

  const showWidgetTables = () => {
    let dashboardWidgets = [
      compareCurrentSubdepartment(
        [...newDashboardMap.Tech.grouphead,
        ...newDashboardMap.All.user], currSubDepartment) ? (
        <DashboardGroupHeadTech
          key="dashboard-gh-tech"
          isTechGroupHeadDealLogLoading={isTechGroupHeadDealLogLoading}
          isTechGroupHeadDealTrackerLoading={isTechGroupHeadDealTrackerLoading}
          groupHeadDealTrackerItems={techGroupHeadDealTrackerItems}
          groupHeadDealLogItems={techGroupHeadDealLogItems}
        />
      ) : null,
      compareCurrentSubdepartment(
        [...newDashboardMap.Tech.user_sf,
        ...newDashboardMap.Tech.user_ny,
        ...newDashboardMap.All.user], currSubDepartment)
        ? isTechBankerTimeLogLoading
          ? <DashboardGridSkeleton width="95vw" />
          : <DashboardTechBanker techBankerTimeLogItems={techBankerTimeLogItems} />
        : null,
      (compareCurrentSubdepartment(
        [...newDashboardMap.SD.user,
        ...newDashboardMap.SD.staffer,
        ...newDashboardMap.SD.manager,
        ...newDashboardMap.All.user], currSubDepartment))
        ? isSponsorLoading
          ? <DashboardGridSkeleton />
          : <DashboardSponsorshipDonations items={sponsorshipItems} currSubDepartment={currSubDepartment} />
        : null,

      (compareCurrentSubdepartment(
        [...newDashboardMap.FIG.user,
        ...newDashboardMap.FIG.staffer,
        ...newDashboardMap.All.user]
        , currSubDepartment))
        ? isFigAssociateLoading
          ? <DashboardGridSkeleton />
          : <DashboardFIG type="Associate" items={FIGAssociateItems} />
        : null,
      (compareCurrentSubdepartment(
        [...newDashboardMap.FIG.user,
        ...newDashboardMap.FIG.staffer,
        ...newDashboardMap.All.user]
        , currSubDepartment))
        ? isFigAnalystLoading
          ? <DashboardGridSkeleton />
          : <DashboardFIG type="Analyst" items={FIGAnalystItems} />
        : null,

      compareCurrentSubdepartment(
        [...newDashboardMap.PUI.user,
        ...newDashboardMap.All.user], currSubDepartment)
        ? isPowerBankerTimeLogLoading
          ? <DashboardGridSkeleton width="95vw" />
          : <DashboardPowerBanker powerBankerTimeLogItems={powerBankerTimeLogItems} />
        : null,

      compareCurrentSubdepartment(
        [...newDashboardMap.PUI.staffer,
        ...newDashboardMap.All.user], currSubDepartment)
        ? isPowerStafferProjectAndMemberTrackerLoading
          ? <>
            <DashboardGridSkeleton width="95vw" />
            <DashboardGridSkeleton width="95vw" />
          </>
          : <DashboardPowerStaffer powerStafferProjectAndMemberTrackerItems={powerStafferProjectAndMemberTrackerItems} />
        : null,

      //banker
      compareCurrentSubdepartment(
        [...newDashboardMap.LF.user,
        ...newDashboardMap.All.user], currSubDepartment)
        ? <LevfinJuniorBanker 
          levfinJuniorBankerTimeLogItems={levfinBankerTimeLogItems}
          levfinDealTrackerItems={levfinDealTrackerItems}
          isLevfinBankerTimeLogLoading={isLevfinBankerTimeLogLoading}
          isLevfinDealTrackerLoading={isLevfinDealTrackerLoading} />
        : null,
      //staffer
      compareCurrentSubdepartment(
        [...newDashboardMap.All.user,
        ...newDashboardMap.LF.grouphead,
        ...newDashboardMap.LF.staffer], currSubDepartment)
        ? <LevfinStaffer 
          levfinStafferTimeLogItems={levfinStafferTimeLogItems}
          levfinDealTrackerItems={levfinDealTrackerItems}
          isLevfinStafferTimeLogLoading={isLevfinStafferTimeLogLoading}
          isLevfinDealTrackerLoading={isLevfinDealTrackerLoading} 
          fetchLevfinStafferTimeLog={fetchLevfinStafferTimeLog}
          setIsLevfinStafferTimeLogLoading={setIsLevfinStafferTimeLogLoading}/>
        
        : null,

      compareCurrentSubdepartment(
        [...newDashboardMap.Energy.user,
        ...newDashboardMap.All.user], currSubDepartment)
        ? isEnergyBankerTimeLogLoading
          ? <DashboardGridSkeleton width="95vw" />
          : <DashboardEnergyBanker energyBankerTimeLogItems={energyBankerTimeLogItems} isSI={false} />
        : null,

      compareCurrentSubdepartment(
        [...newDashboardMap.Energy.staffer,
        ...newDashboardMap.All.user], currSubDepartment)
        ? <DashboardEnergyStaffer
          energyStafferTimeLogItems={energyStafferTimeLogItems}
          isEnergyStafferTimeLogLoading={isEnergyStafferTimeLogLoading}
          setIsEnergyStafferTimeLogLoading={setIsEnergyStafferTimeLogLoading}
          fetchEnergyTechStafferTimeLog={fetchEnergyTechStafferTimeLog}
          energyStafferDealResourceLogItems={energyStafferDealResourceLogItems}
          isEnergyStafferDealResourceLogLoading={isEnergyStafferDealResourceLogLoading}
          setIsEnergyStafferDealResourceLogLoading={setIsEnergyStafferDealResourceLogLoading}
          fetchStafferDealDetailsandResourcingLog={fetchStafferDealDetailsandResourcingLog}
          energyJuniorStaffingIndexData={energyJuniorStaffingIndexData}
          isEnergyJuniorStaffingIndexLoading={isEnergyJuniorStaffingIndexLoading}
          setIsEnergyJuniorStaffingIndexLoading={setIsEnergyJuniorStaffingIndexLoading}
          fetchEnergyJuniorStaffingIndex={fetchEnergyJuniorStaffingIndex}
          energyProjectHoursByVerticalData={energyProjectHoursByVerticalData}
          isEnergyProjectHoursByVerticalLoading={isEnergyProjectHoursByVerticalLoading}
          setIsEnergyProjectHoursByVerticalLoading={setIsEnergyProjectHoursByVerticalLoading}
          fetchEnergyProjectHoursByVertical={fetchEnergyProjectHoursByVertical}
          isSI={false}
        />
        : null,

      compareCurrentSubdepartment(
        [...newDashboardMap.EnergySI.user,
        ...newDashboardMap.All.user], currSubDepartment)
        ? isEnergySIBankerTimeLogLoading
          ? <DashboardGridSkeleton width="95vw" />
          : <DashboardEnergyBanker energyBankerTimeLogItems={energySIBankerTimeLogItems} isSI={true} />
        : null,

      compareCurrentSubdepartment(
        [...newDashboardMap.EnergySI.staffer,
        ...newDashboardMap.All.user], currSubDepartment)
        ? <DashboardEnergyStaffer
          energyStafferTimeLogItems={energySIStafferTimeLogItems}
          isEnergyStafferTimeLogLoading={isEnergySIStafferTimeLogLoading}
          setIsEnergyStafferTimeLogLoading={setIsEnergySIStafferTimeLogLoading}
          fetchEnergyTechStafferTimeLog={fetchEnergySIStafferTimeLog}
          energyStafferDealResourceLogItems={energySIStafferDealResourceLogItems}
          isEnergyStafferDealResourceLogLoading={isEnergySIStafferDealResourceLogLoading}
          setIsEnergyStafferDealResourceLogLoading={setIsEnergySIStafferDealResourceLogLoading}
          fetchStafferDealDetailsandResourcingLog={fetchEnergySIStafferDealDetailsandResourcingLog}
          energyJuniorStaffingIndexData={energyJuniorStaffingIndexData}
          isEnergyJuniorStaffingIndexLoading={isEnergyJuniorStaffingIndexLoading}
          setIsEnergyJuniorStaffingIndexLoading={setIsEnergyJuniorStaffingIndexLoading}
          fetchEnergyJuniorStaffingIndex={fetchEnergyJuniorStaffingIndex}
          energyProjectHoursByVerticalData={energyProjectHoursByVerticalData}
          isEnergyProjectHoursByVerticalLoading={isEnergyProjectHoursByVerticalLoading}
          setIsEnergyProjectHoursByVerticalLoading={setIsEnergyProjectHoursByVerticalLoading}
          fetchEnergyProjectHoursByVertical={fetchEnergyProjectHoursByVertical}
          isSI={true}
        />
        : null,

      <DashboardEmailPerformance items={emailItems} />,
      <DashboardEmailStatus items={emailItems} />,

      compareCurrentSubdepartment(
        [...newDashboardMap.HC.user,
        ...newDashboardMap.HC.staffer,
        ...newDashboardMap.All.user], currSubDepartment)
        ? isHealthLoading
          ? <DashboardGridSkeleton />
          : <DashboardHealthcare items={healthcareItems} currSubDepartment={currSubDepartment} />
        : null,

      (compareCurrentSubdepartment(
        [...newDashboardMap.CR.user,
        ...newDashboardMap.CR.staffer,
        ...newDashboardMap.All.user]
        , currSubDepartment)) ? (
        <DashboardConsumerRetail
          memberItems={consumerMemberTimeItems}
          fetchData={fetchConsumerMemberTimeData}
          projectItems={consumerProjectTimeItems}
          isConsumerMemberLoading={isConsumerMemberLoading}
          isConsumerProjectLoading={isConsumerProjectLoading}
        />
      ) : null,

      compareCurrentSubdepartment(
        [...newDashboardMap.GPC.user,
        ...newDashboardMap.All.user]
        , currSubDepartment) ? (
        <DashboardGPC
          memberItems={GPCMemberTimeItems}
          fetchData={fetchGPCMemberTimeData}
          projectItems={GPCProjectTimeItems}
          isGPCMemberLoading={isGPCMemberLoading}
          isGPCProjectLoading={isGPCProjectLoading}
        />
      ) : null,

      (compareCurrentSubdepartment(
        [...newDashboardMap.MA.user,
        ...newDashboardMap.MA.staffer,
        ...newDashboardMap.All.user]
        , currSubDepartment))
        ? isMergerAssociateLoading
          ? <DashboardGridSkeleton />
          : <DashboardMergersAndAcquisitions
            type="Associate"
            users={mergersAndAcquisitionsAssociateUsers}
            setUsers={setMergersAndAcquisitionsAssociateUsers}
          />
        : null,

      (compareCurrentSubdepartment(
        [...newDashboardMap.MA.user,
        ...newDashboardMap.MA.staffer,
        ...newDashboardMap.All.user]
        , currSubDepartment))
        ? isMergerAnalystLoading
          ? <DashboardGridSkeleton />
          : <DashboardMergersAndAcquisitions
            type="Analyst"
            users={mergersAndAcquisitionsAnalystUsers}
            setUsers={setMergersAndAcquisitionsAnalystUsers}
          />
        : null,

      <DashboardCME
        memberItems={cMEMemberItems}
        fetchData={fetchCMEMemberTimeData}
        projectItems={cMEProjectItems}
        groupHeadProjectItems={cMEGroupHeadProjectItems}
        groupHeadDealitems={cMEGroupHeadDealItems}
        currSubDepartment={currSubDepartment}
        isCMEGroupHeadDealLoading={isCMEGroupHeadDealLoading}
        isCMEGroupHeadProjectLoading={isCMEGroupHeadProjectLoading}
        isCMEMemberLoading={isCMEMemberLoading}
        isCMEProjectLoading={isCMEProjectLoading}
      />,

      (compareCurrentSubdepartment(
        [...newDashboardMap.RE.user,
        ...newDashboardMap.RE.staffer,
        ...newDashboardMap.All.user]
        , currSubDepartment)) ? (
        <DashboardRealEstate
          realEstateUsers={realEstateUsers}
          fetchData={fetchRealEstateData}
          isRELoading={isRELoading}
          currSubDepartment={currSubDepartment}
        />
      ) : null,

      compareCurrentSubdepartment([...newDashboardMap.L2L.user], currSubDepartment) ? (
        <DashboardL2L key="dashboard-l2l" L2LWidgetData={L2LRevenueChartData} />
      ) : null,
    ];

    let widgetTableDisplay = dashboardWidgets.map((widget, index) => {
      return (
        <div className="new-dashboard main-dashboard-container" key={index}>
          {widget}
        </div>
      );
    });

    return widgetTableDisplay;
  };

  const showDashboardTables = () => {
    let dashboardContent = null;
    if (showDashboard) {
      if (isLoading) {
        dashboardContent = (
          <div className="pulse-loader-container">
            <Helmet>
              <title>TRIYO · Dashboards</title>
            </Helmet>
            <div className="pulse-loader">
              <PulseLoader></PulseLoader>
            </div>
          </div>
        );
      }
      if (departments && currDepartment && !isLoading) {
        dashboardContent = (
          <div className="dashboard-container d-flex flex-column align-items-center">
            <Helmet>
              <title>TRIYO · Dashboards</title>
            </Helmet>
            <div className="new-dashboard mt2 w-100">
              <DashboardHeader
                departments={departments}
                currDepartment={currDepartment}
                setCurrDepartment={setCurrDepartment}
                fetchDepartmentData={fetchDepartmentData}
                subDepartments={subDepartments}
                setSubCurrDepartment={setSubCurrDepartment}
                currSubDepartment={currSubDepartment}
                refreshLoading={refreshLoading}
              />
            </div>

            {compareCurrentSubdepartment(
                [...newDashboardMap.Tech.staffer_sf,
                ...newDashboardMap.Tech.staffer_ny,
                ...newDashboardMap.Tech.admin_sf,
                ...newDashboardMap.Tech.admin_ny,
                ...newDashboardMap.All.user], currSubDepartment) ?
              (isGIBLoading ?
                <>
                  <DashboardGridSkeleton width="95vw" />
                  {!compareCurrentSubdepartment([...newDashboardMap.Tech.user_sf, ...newDashboardMap.Tech.user_ny], currSubDepartment) && (
                    <DashboardGridSkeleton width="95vw" />
                  )}
                </>
                :
                (<div className="new-dashboard mt">
                  <DashboardTechStaffer
                    techBankerTimeLogData={dashboardData.dynamicFields?.Item1}
                    isAdmin={dashboardData.dynamicFields?.Item2}
                    isStaffer={dashboardData.dynamicFields?.Item3}
                    currSubDepartment={currSubDepartment}
                  />
                </div>)) : null
            }
            {showWidgetTables()}
          </div>
        );
      }
    } else {
      dashboardContent = <NoPermissionTable />;
    }

    return dashboardContent;
  };

  return <React.Fragment>{showDashboardTables()}</React.Fragment>;
};

export default NewDashboard;
